export default __webpack_public_path__ + "static/media/Background_00290.f97e6f7c.png";